import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CustomerPaymentView from '../../components/CustomerPaymentView';
import Icon, { GLYPHS } from '../../../common/icon';
import CountryCodePhoneInput from '../../../common/countryCodePhoneInput';
import { t } from '../../../../modules/infra/i18n';

const Receipt = ({
  email,
  phone,
  onEmailChange,
  onPhoneChange,
  onNoReceipt,
  submitEmail,
  submitPhone,
  emailValid,
  phoneValid,
  total,
  loading,
  error,
  shouldShowSms,
}) => (
  <CustomerPaymentView total={total} subtitle={t('register:receipt.subtitle')} loading={loading}>
    <div className="c-customer-view-panel">
      <form
        onSubmit={submitPhone}
        className={classnames('c-customer-view-receipt-input', {
          'is-disabled': loading,
        })}
        display-if={shouldShowSms}
      >
        <div className="u-flex u-align-items-center">
          <Icon className="c-customer-view-receipt-input__icon" glyph={GLYPHS.message} size="small" />
          <CountryCodePhoneInput
            className="c-customer-view-receipt-input__input c-customer-view-receipt-input__phone-input"
            placeholder={t('register:receipt.phone_placeholder')}
            onChange={onPhoneChange}
            value={phone}
            disabled={loading}
          />
        </div>
        <button
          type="submit"
          className="c-btn c-btn--medium u-width-140"
          disabled={!phoneValid || loading}
          data-automation-id="button:sendReceiptPhone"
        >
          {t('register:receipt.send_button')}
        </button>
      </form>
      <form
        onSubmit={submitEmail}
        className={classnames('c-customer-view-receipt-input', {
          'is-disabled': loading,
        })}
      >
        <Icon className="c-customer-view-receipt-input__icon" glyph={GLYPHS.email} size="small" />
        <input
          type="email"
          className="c-customer-view-receipt-input__input"
          placeholder={t('register:receipt.email_placeholder')}
          onChange={onEmailChange}
          value={email}
          disabled={loading}
          data-automation-id="input:customerEmail"
        />
        <button
          type="submit"
          className="c-btn c-btn--medium u-width-140"
          disabled={!emailValid || loading}
          data-automation-id="button:sendReceiptEmail"
        >
          {t('register:receipt.send_button')}
        </button>
      </form>
      <button
        type="button"
        onClick={onNoReceipt}
        className="c-customer-view-receipt-button"
        disabled={loading}
        data-automation-id="button:NoReceipt"
      >
        <Icon className="c-customer-view-receipt-button__icon" glyph={GLYPHS.forbidden} size="small" />
        {error ? t('register:receipt.close_button') : t('register:receipt.no_thanks_button')}
      </button>
    </div>
  </CustomerPaymentView>
);

Receipt.propTypes = {
  phone: PropTypes.string,
  email: PropTypes.string,
  onEmailChange: PropTypes.func.isRequired,
  onPhoneChange: PropTypes.func.isRequired,
  onNoReceipt: PropTypes.func.isRequired,
  submitEmail: PropTypes.func.isRequired,
  submitPhone: PropTypes.func.isRequired,
  emailValid: PropTypes.bool.isRequired,
  phoneValid: PropTypes.bool.isRequired,
  total: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  shouldShowSms: PropTypes.bool.isRequired,
};

Receipt.defaultProps = {
  phone: '',
  email: '',
};

export default Receipt;
